export default __webpack_public_path__ + "static/media/buy.27f83563.png";